import type { ClientInfoPageData } from './types';
import { fetchClientInfoPage, isValidUUID, getAgentAdminHost } from './fetcher';

export type ClientInfoPagesApiType = {
  /**
   * Fetches a client info page by UUID
   *
   * @param uuid The unique identifier for the client info page
   * @param signal Optional AbortSignal for cancellation
   * @returns A promise that resolves to the client info page data, or null if not found/expired
   */
  getClientInfoPage: (uuid: string, signal?: AbortSignal) => Promise<ClientInfoPageData | null>;

  /**
   * Validates if a string is a valid UUID format
   *
   * @param str The string to validate
   * @returns True if the string is a valid UUID
   */
  isValidUUID: (str: string) => boolean;
};

class ClientInfoPagesApi implements ClientInfoPagesApiType {
  private constructor(private readonly host: string) {}

  /**
   * Creates a new ClientInfoPagesApi instance
   *
   * @param host The host to use for API requests. Defaults to agent-admin host from environment.
   * @returns A new ClientInfoPagesApi instance
   */
  static create(host: string = getAgentAdminHost()): ClientInfoPagesApi {
    return new ClientInfoPagesApi(host);
  }

  getClientInfoPage(uuid: string, signal?: AbortSignal): Promise<ClientInfoPageData | null> {
    return fetchClientInfoPage(uuid, signal);
  }

  isValidUUID(str: string): boolean {
    return isValidUUID(str);
  }
}

/**
 * Creates a new ClientInfoPagesApi instance
 *
 * @param host The host to use for API requests. Defaults to agent-admin host from environment.
 * @returns A new ClientInfoPagesApi instance
 */
export const createClientInfoPagesApi = ClientInfoPagesApi.create;
